import React, { useState, useEffect } from 'react';
import SettingIcon from 'assets/icon/SettingIcon';
import DashboardIcon from 'assets/icon/DashboardIcon';
import TransferIcon from 'assets/icon/TransferIcon';
import UserIcon from 'assets/icon/UserIcon';
import MenuIcon from 'assets/icon/MenuIcon';
import BankIcon from 'assets/icon/BankIcon';

export default function Sidebar({ onSidebarClick, menuAccess }) {
	// const [isOpen, setIsOpen] = useState(localStorage.getItem("SidebarState") === "open" ? true : false);
	const [isOpen, setIsOpen] = useState(true);

	let pathArray = window.location.pathname.split("/")
	
	const logoutBtnClick = () => {
		localStorage.removeItem("Token")
		localStorage.removeItem("Username")
		localStorage.removeItem("FirstName")
		localStorage.removeItem("LastName")
		localStorage.removeItem("Email")

		window.location.href = "/login"
	}
	const toggleSidebar = () => {
		setIsOpen(prev => {
			const next = !prev;
			localStorage.setItem("SidebarState", next ? "open" : "close");
			return next;
		});
	};

	useEffect(() => {
		// setIsAdmin(localStorage.getItem("IsAdmin"))
		// setIsAdmin("1")
	}, [])
  
	return (
		<div className={`fixed sm:relative h-screen bg-white shadow-md transition-all z-20 ${ isOpen ? 'w-64' : 'hidden sm:block sm:w-20' } `}>
			<div className={`h-screen flex flex-col gap-2 lg:text-base py-4 w-full`}>
				<div className={`flex gap-3 ${ isOpen ? 'justify-start' : 'justify-center' } px-4`}>
					<button className='hidden' onClick={toggleSidebar}>
						<MenuIcon className='fill-black w-5' />
					</button>
					{ isOpen && (<span className={`font-semibold italic text-xl`}>Parkhub</span>)}
				</div>

				<div className='px-4'>
					<span className='text-xs'>{ localStorage.getItem("Name") !== null && localStorage.getItem("Name") !== '' ? localStorage.getItem("Name").toUpperCase() : '' }</span>

				</div>

				<div className="items-start flex flex-col w-full gap-2 px-4 overflow-y-auto">
					
					<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/' ? 'bg-black text-white fill-white' : '' } 
							${ isOpen ? 'px-4' : 'justify-center px-2' } 
						`}
						onClick={onSidebarClick}
						href="/"
					>
						<DashboardIcon className='w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Dashboard</p>
					</a>

					<div className={`
							${ isOpen ? 'block' : 'hidden' }
						`}>
						<span className='text-gray-400'>Transaction</span>
					</div>
					
					<SidebarCard
						title='Client'
						path='/client'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<BankIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Billing'
						path='/billing'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<TransferIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Customer Login'
						path='/customer-login'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<UserIcon className='w-6' />
					</SidebarCard>
{/* 
					<div className={`
							${ isOpen ? 'block' : 'hidden' }
						`}>
						<span className='text-gray-400'>Master Data</span>
					</div>

					<SidebarCard
						title='Sales Stock'
						path='/sales-stock'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<PackageIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Rental Stock'
						path='/rental-stock'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<PackageIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Product'
						path='/product'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<PackageIcon className='w-6' />
					</SidebarCard>
					
					<SidebarCard
						title='Brand'
						path='/brand'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<HalfStarIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Category'
						path='/category'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<CategoryIcon className='w-6 h-6' />
					</SidebarCard> */}
					
					<SidebarCard
						title='Setting'
						path='/setting'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<SettingIcon className='w-6' />
					</SidebarCard>

					<button className='mt-5 button w-full mb-5' onClick={logoutBtnClick}>
						<span>Log Out</span>
					</button>
				</div>
			</div>	
		</div>
  	)
}

const SidebarCard = ({ title, path, isOpen, onClick, children }) => {
	return(
		<a
			className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				${ window.location.pathname.includes(path) ? 'bg-black text-white fill-white' : '' } 
				${ isOpen ? 'px-4' : 'justify-center px-2' }
			`}
			onClick={onClick}
			href={ path }
		>
			{ children }
			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>{ title }</p>
		</a>
	)
}
